// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineStrikethrough = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.113 20.32C8.25305 20.32 5.65305 18.28 5.65305 14.8H7.95305C8.03305 17.06 9.55305 18.4 12.193 18.4C14.733 18.4 16.153 17.28 16.153 15.44C16.153 10.98 6.09305 15.36 6.09305 8.6C6.09305 5.96 8.45305 4.08 12.033 4.08C15.633 4.08 18.153 6.1 18.153 9.12H15.913C15.753 7.16 14.353 6 11.973 6C9.59305 6 8.27305 7.04 8.27305 8.82C8.27305 12.98 18.353 8.82 18.353 15.44C18.353 18.24 16.113 20.32 12.113 20.32Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.37305 13.76H19.633V14.76H4.37305V13.76Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineStrikethrough };
